import React from "react";
import { truncate } from "lodash";
import moment from "moment";
import "./style/import-installed-app.scss";

interface IImportInstalledApp {
  setVisible: any;
  apps: [];
  activeTab: string;
  setSelectedApp: any;
  searchValue: string;
}

const getFormatDescription = (value: string, length: number) =>
  truncate(value, { length, separator: " " });

export const ImportInstalledApp: React.FC<IImportInstalledApp> = ({ apps, activeTab, setVisible, setSelectedApp, searchValue }) => {
  const handleImportApp = async (appData: string) => {
    setVisible({ visible: true, type: "Import" });
    setSelectedApp(appData);
  };

  return (
    <div className="app-import-card">
      {apps.filter((e: any) => e.name?.toLowerCase()?.includes(searchValue.toLowerCase())).map((app: any) => {
        return (
        <div
          key={app.id}
          className="import-card"
        >
          <div className="icon-info">
            <div className="info">
              <h4 className="hl">{app.name}</h4>
              <p>{getFormatDescription(app.description, 77)}</p>
            </div>
          </div>

          <div className="author-install">
            <div className="author">
              <div className="author-name">
                By:{" "}
                <span className="hl">
                  {app.created_by.first_name} {app.created_by.last_name}
                </span>
              </div>
              <div className="author-date">
                updataed on:{" "}
                <span className="hl">{moment(app.created_at).format("MMM DD, YYYY")}</span>
              </div>
            </div>
            <div className="install">
              {activeTab === "Installed Apps" &&
                <button
                  data-test-id="import"
                  onClick={() => handleImportApp(app)}
                  className={`${app.is_installed ? "btn-installed" : "btn-install"}`}
                >
                  Import
                </button>
              }
              <div className="version-updated">
                <p>
                  Version: <span className="hl">{app.version_tag}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      )})}
    </div>
  );
};
